import React, { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { PDFDocument, rgb } from "pdf-lib";

export const PaymentInformation = ({ transactions, isLoading }) => {
  const [isEditing, setIsEditing] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const jsonData = transactions.map((e) => {
    return {
      // "payment method": e.payment_method.id,
      customer: e.customer,
      amount: e.amount / 100,
      currency: e.currency,
      status: e.status,
      "Last charge": e.latest_charge,
      "Card number": "**** " + e.payment_method.card.last4,
      "Payment method": e.payment_method.card.display_brand,
      "Course name": e.classId.courseName,
      "Section code": e.sectionId.joinCode,
    };
  });
  const createPdf = async () => {
    // Create a new PDF document
    const pdfDoc = await PDFDocument.create();

    // Add a new page to the document
    const page = pdfDoc.addPage([1000, 500]); // Adjust page width as needed

    // Set up table properties
    const table = {
      startX: 50,
      startY: 500 - 50, // Adjust startY as per your requirement
      rowHeight: 30,
      borderWidth: 1,
      font: await pdfDoc.embedFont("Helvetica"), // You can use any font you like
      fontSize: 8,
      boldFontSize: 10,
      textColor: rgb(0, 0, 0),
    };

    // Function to draw table cell
    const drawCell = (text, x, y, height, fontSize) => {
      const textWidth = table.font.widthOfTextAtSize(text, table.fontSize);
      const cellWidth = textWidth + 10; // Add some padding
      page.drawText(text, {
        x,
        y,
        width: cellWidth,
        height,
        font: table.font,
        size: fontSize || table.fontSize,
        color: table.textColor,
        lineHeight: height, // Set line height equal to cell height
        lineGap: 0, // Remove line gap
      });
    };

    // Function to draw table
    const drawTable = () => {
      // Draw table headers
      let currentX = table.startX;
      Object.keys(jsonData[0]).forEach((key) => {
        const val = jsonData[0][key] ? jsonData[0][key].toString() : "--";
        const cellWidth =
          table.font.widthOfTextAtSize(
            key.length > val.length ? key : val,
            table.fontSize
          ) + 22; // Add some padding
        drawCell(
          key,
          currentX,
          table.startY,
          table.rowHeight,
          table.boldFontSize
        );
        currentX += cellWidth;
      });

      // Draw table rows
      let currentY = table.startY - table.rowHeight;
      jsonData.forEach((data) => {
        currentX = table.startX;
        Object.entries(data).forEach(([key, value]) => {
          const text = value ? value.toString() : "--";
          const cellWidth =
            table.font.widthOfTextAtSize(
              key.length > text.length ? key : text,
              table.fontSize
            ) + 22; // Add some padding
          drawCell(text, currentX, currentY, table.rowHeight);
          currentX += cellWidth; // Adjust for the next column
        });
        currentY -= table.rowHeight; // Adjust for the next row
      });
    };

    // Draw table
    drawTable();

    // Serialize the PDF document to bytes
    const pdfBytes = await pdfDoc.save();

    // Convert bytes to a Blob
    const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });

    // Create a URL for the Blob
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfUrl);
  };
  return (
    <div className="box_border_settings border-grey">
      <div className="settings_header">
        <h2>payment information</h2>
      </div>
      {!isLoading ? (
        <Fragment>
          {transactions.length ? (
            <Fragment>
              <div className="setting_rows">
                <p className="key">Current Semester</p>
                <p className="">
                  <span>
                    {new Set(transactions.map((e) => e.classId._id)).size}{" "}
                    classes{" "}
                    {transactions.map((trans, index) => (
                      <span style={{ textTransform: "none" }}>
                        ({trans.sectionId.joinCode + ", "})
                      </span>
                    ))}
                  </span>
                </p>
              </div>
              <div className="setting_rows">
                <p className="key">Subscription</p>
                <p className="value">
                  Paid for fall semester{" "}
                  {new Date(transactions[0].classId.startDate).getFullYear()} (
                  {new Date(transactions[0].classId.startDate).toLocaleString(
                    "default",
                    { month: "long" }
                  )}{" "}
                  -{" "}
                  {new Date(transactions[0].classId.endDate).toLocaleString(
                    "default",
                    { month: "long" }
                  )}
                  ){/* <input type="text" value={"*********"} /> */}
                </p>
              </div>
              <div className="setting_rows">
                <p className="key">Payment info</p>
                <p className="value">
                  Update or change payment information on stripe
                  <Link>click here</Link>
                </p>
              </div>
              <div className="setting_rows">
                <p className="key">Payment history</p>
                <p className="value">
                  View a PDF of payment history using greyled
                  <a onClick={createPdf} target="__blank" href="#!">
                    click here
                  </a>
                </p>
              </div>
            </Fragment>
          ) : (
            "NO PAYMENT INFORMATION TO SHOW"
          )}
        </Fragment>
      ) : (
        "Loading..."
      )}
    </div>
  );
};
